import { IMsg } from '../model/im';
import { RealImageInfo } from '../model/chat';
import { TPosition } from '../model/position';
import { TOperationSetting } from '../model/chat/message-operate';
import { ISimpleUser } from '../model/user';

export type GrpNickChangeEvent = {
  gid: string;
  oldNick: string;
  newNick: string;
};

export type GroupInfoChangeEvent = {
  groupOperateType: number;
};

export type AvatarClickEvent = {
  uid: string;
  userInfo?: ISimpleUser;
};

export type PictureClickEvent = {
  messageInfo: IMsg;
  imageInfo: RealImageInfo;
};

export enum ChatPageEventType {
  avatarClick = 'avatar-click',
  pictureClick = 'picture-click',
  customUiPictureClick = 'custom-ui-picture-click',
  editGrpNick = 'edit-grp-nick',
  addSticker = 'add-sticker',
  resendClick = 'resend-click',
  messageHighlight = 'message-hight',
  messageOperateOptions = 'message_operate_options',
  messageReactionOptions = 'message_reaction_options',
  messageSelectClick = 'message-select-click',
  longPressAvatar = 'long-press-avatar',
  showMessageOperate = 'show-message-operate',
  hideMessageOperate = 'hide-message-operate',
  showReaction = 'show-reaction',
  hideReaction = 'hide-reaction',
  clickMessageOperateOption = 'click-message-operate-option',
  clickMessageReedit = 'click-message-reedit',
  updateTopicList = 'update-topic-list',
  openTopicDetail = 'open-topic-detail',
  editPanelAddTopic = 'edit-panel-add-topic',
  channelTopMessageScroll = 'channel-top-message-scroll',
  channelTopMessageClose = 'channel-top-message-close',
  chatListScrollToBottom = 'chat-list-scroll-to-bottom',
}

/**
 * 链接相关事件类型
 */
export enum LinkEventType {
  /** 链接解析 */
  resolve = 'resolve',
}

export type EditGrpNickEvent = {
  gid: string;
};

export type TAddStickerEvent = Record<string, unknown>;

export type ResendClickEvent = {
  messageInfo: IMsg;
};

export type TMessageHighLightEvent = {
  messageSeq: string;
};

export type MessageSelectClickEvent = {
  messageInfo: IMsg;
};

export type ChatMessageOperateOptionsEvent = {
  visible: boolean;
  position?: TPosition;
  message?: IMsg;
  operateList?: Array<TOperationSetting>
};

export type ShowMessageOperateEvent = {
  position: TPosition;
  message: IMsg;
  operateList: Array<TOperationSetting>
};

export type HideMessageOperateEvent = Record<string, unknown>;

export type TShowReactionEvent = {
  position: TPosition;
  message: IMsg;
};

export type THideReactionEvent = Record<string, unknown>;

export type ChatLongPressAvatarEvent = {
  userId: string;
  name: string;
  showNick?: string;
};

export type ClickMessageOperateOptionEvent = {
  option: TOperationSetting;
  message: IMsg;
  position: TPosition;
};

export type ClickMessageReeditEvent = {
  messageData: IMsg;
};

export type UpdateTopicListEvent = {
  channelId: string;
  topicId: string;
  count: number;
  isForceUpdate: boolean;
};

export type OpenTopicDetailEvent = {
  channelId: string;
  topicId: string;
  from: number;
};

export type EditPanelAddTopicEvent = {
  topicId: string;
  topicName: string;
  from: number;
};

export type TopScrollEvent = {
  topMessageSequence: number;
};

export type TopCloseEvent = {
  topClose: boolean;
};

export type ChatPageEvents = {
  [ChatPageEventType.avatarClick]: AvatarClickEvent;
  [ChatPageEventType.pictureClick]: PictureClickEvent;
  [ChatPageEventType.customUiPictureClick]: PictureClickEvent;
  [ChatPageEventType.editGrpNick]: EditGrpNickEvent;
  [ChatPageEventType.addSticker]: TAddStickerEvent;
  [ChatPageEventType.resendClick]: ResendClickEvent;
  [ChatPageEventType.messageHighlight]: TMessageHighLightEvent;
  [ChatPageEventType.messageOperateOptions]: ChatMessageOperateOptionsEvent;
  [ChatPageEventType.messageReactionOptions]: ChatMessageOperateOptionsEvent;
  [ChatPageEventType.messageSelectClick]: MessageSelectClickEvent;
  [ChatPageEventType.longPressAvatar]: ChatLongPressAvatarEvent;
  [ChatPageEventType.showMessageOperate]: ShowMessageOperateEvent;
  [ChatPageEventType.hideMessageOperate]: HideMessageOperateEvent;
  [ChatPageEventType.showReaction]: TShowReactionEvent;
  [ChatPageEventType.hideReaction]: THideReactionEvent;
  [ChatPageEventType.clickMessageOperateOption]: ClickMessageOperateOptionEvent;
  [ChatPageEventType.clickMessageReedit]: ClickMessageReeditEvent;
  [ChatPageEventType.updateTopicList]: UpdateTopicListEvent;
  [ChatPageEventType.openTopicDetail]: OpenTopicDetailEvent;
  [ChatPageEventType.editPanelAddTopic]: EditPanelAddTopicEvent;
  [ChatPageEventType.channelTopMessageScroll]: TopScrollEvent;
  [ChatPageEventType.channelTopMessageClose]: TopCloseEvent;
  [ChatPageEventType.chatListScrollToBottom]: null;
};

export type LinkResolveEvent = {
  /** 链接对应的消息内容 */
  msgContent: string;
  /** 解析成功的链接集合 */
  linkList: string[];
  /** 解析是否已经完成 */
  hasResolveFinish: boolean;
};

export type LinkEvent = {
  [LinkEventType.resolve]: LinkResolveEvent;
};

export enum AppEventType {
  appForeground = 'app_foreground',
  appBackground = 'app_background',
}

// /** app回到前台事件 */
// export type AppForegroundEvent = {};

// /** app退到后台事件 */
// export type AppBackgroundEvent = {};

export type GlobalEvents = {
  group_nick_change: GrpNickChangeEvent;
  group_info_change: GroupInfoChangeEvent;
  [AppEventType.appForeground]: Record<string, unknown>;
  [AppEventType.appBackground]: Record<string, unknown>; // TODO空对象定义类型报错
  // [AppEventType.appForeground]: AppForegroundEvent;
  // [AppEventType.appBackground]: AppBackgroundEvent;
};

export default GlobalEvents;
